import { motion } from "framer-motion";

import { letterAnim } from "@/utils/animations";
import { navLinks } from "@/config/navigation";
import { useScrollToSection } from "@/hooks/useScrollToSection";

const getLetter = (name: string) => {
  return name.split("").map((letter, index) => (
    <motion.span
      key={index}
      animate="enter"
      custom={[index * 0.04, (name.length - index) * 0.01]} // Custom prop for delays
      exit="exit"
      initial="initial"
      variants={letterAnim}
    >
      {letter}
    </motion.span>
  ));
};

const NavList = ({ closeNav }: { closeNav: () => void }) => {
  const scrollTo = useScrollToSection();

  return (
    // Vertical list of navigation links
    <ul className="flex flex-col gap-8 font-primary font-semibold text-accent items-center uppercase">
      {navLinks.map((link, index) => (
        <button
          key={index}
          aria-label={`Go to ${link.name} section`}
          className="flex overflow-hidden text-4xl text-accent hover:text-white transition-all cursor-pointer outline-none focus:text-white"
          onClick={() => {
            scrollTo(link.id);
            closeNav();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              scrollTo(link.id);
              closeNav();
            }
          }}
          // overflow-hidden: Clips letters during animation (prevents overflow during y: "100%")
        >
          {/* Render letters with animation for each link */}
          {getLetter(link.name)}
        </button>
      ))}
    </ul>
  );
};

export default NavList;
